import React, { useState } from 'react';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, BarChart3, Settings2, History, Calendar as CalendarIcon, TrendingUp, AlertTriangle, CheckCircle2, ChevronLeft, ChevronRight, Plus, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
const utilizationData = [{
  name: 'Mon',
  usage: 85
}, {
  name: 'Tue',
  usage: 42
}, {
  name: 'Wed',
  usage: 100
}, {
  name: 'Thu',
  usage: 65
}, {
  name: 'Fri',
  usage: 20
}, {
  name: 'Sat',
  usage: 15
}, {
  name: 'Sun',
  usage: 10
}];
export function CapacityManagement() {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'calendar' | 'config'>('dashboard');
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-273">
      <header className="bg-white px-4 py-6 border-b border-slate-200 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-274">
        <div className="flex items-center gap-4" data-id="element-275">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-276">
            <ArrowLeft size={24} data-id="element-277" />
          </button>
          <BilingualText en="Capacity Management" ar="إدارة السعة" className="text-xl font-bold" data-id="element-278" />
        </div>
        <div className="flex gap-2" data-id="element-279">
          <Link to="/settings" className="btn-secondary py-2 px-4 text-sm hidden sm:flex" data-id="element-280">
            <Settings2 size={18} data-id="element-281" />
            <span data-id="element-282">Configuration</span>
          </Link>
        </div>
      </header>

      <main className="p-4 md:p-8 max-w-7xl mx-auto space-y-8" data-id="element-283">
        {/* Tab Navigation */}
        <div className="flex border-b border-slate-200 gap-8" data-id="element-284">
          <TabButton active={activeTab === 'dashboard'} onClick={() => setActiveTab('dashboard')} en="Dashboard" ar="لوحة التحكم" data-id="element-285" />
          <TabButton active={activeTab === 'calendar'} onClick={() => setActiveTab('calendar')} en="Capacity Calendar" ar="تقويم السعة" data-id="element-286" />
          <TabButton active={activeTab === 'config'} onClick={() => setActiveTab('config')} en="Adjustments" ar="التعديلات" data-id="element-287" />
        </div>

        {activeTab === 'dashboard' && <div className="space-y-8 animate-in fade-in duration-500" data-id="element-288">
            {/* KPI Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-289">
              <CapacityKpi title="Daily Capacity" value="10,000" unit="Cartons" icon={BarChart3} color="text-blue-600" bgColor="bg-blue-50" data-id="element-290" />
              <CapacityKpi title="Used Capacity" value="6,850" unit="68.5%" icon={TrendingUp} color="text-orange-600" bgColor="bg-orange-50" data-id="element-291" />
              <CapacityKpi title="Remaining" value="3,150" unit="Cartons" icon={CheckCircle2} color="text-green-600" bgColor="bg-green-50" data-id="element-292" />
              <CapacityKpi title="Appointments" value="24" unit="Confirmed" icon={CalendarIcon} color="text-purple-600" bgColor="bg-purple-50" data-id="element-293" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-294">
              {/* Main Progress Visualization */}
              <div className="lg:col-span-2 card p-6 space-y-6" data-id="element-295">
                <div className="flex justify-between items-end" data-id="element-296">
                  <BilingualText en="Current Utilization" ar="الاستخدام الحالي" className="text-lg" data-id="element-297" />
                  <span className="text-3xl font-black text-orange-600" data-id="element-298">
                    68%
                  </span>
                </div>
                <div className="w-full bg-slate-100 h-8 rounded-2xl overflow-hidden flex" data-id="element-299">
                  <div className="bg-orange-500 h-full transition-all duration-1000" style={{
                width: '68%'
              }} data-id="element-300" />
                </div>
                <div className="grid grid-cols-3 text-center gap-4" data-id="element-301">
                  <div className="p-3 bg-slate-50 rounded-xl" data-id="element-302">
                    <div className="text-xs text-slate-400 font-bold uppercase" data-id="element-303">
                      Target
                    </div>
                    <div className="font-bold" data-id="element-304">7,000</div>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-xl border-2 border-orange-100" data-id="element-305">
                    <div className="text-xs text-slate-400 font-bold uppercase" data-id="element-306">
                      Actual
                    </div>
                    <div className="font-bold text-orange-600" data-id="element-307">6,850</div>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-xl" data-id="element-308">
                    <div className="text-xs text-slate-400 font-bold uppercase" data-id="element-309">
                      Peak
                    </div>
                    <div className="font-bold" data-id="element-310">9,200</div>
                  </div>
                </div>
              </div>

              {/* Weekly Trend */}
              <div className="card p-6 space-y-4" data-id="element-311">
                <BilingualText en="Weekly Trend" ar="الاتجاه الأسبوعي" className="text-lg" data-id="element-312" />
                <div className="h-48 w-full" data-id="element-313">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-314">
                    <BarChart data={utilizationData} data-id="element-315">
                      <Bar dataKey="usage" fill="#2E3192" radius={[4, 4, 0, 0]} data-id="element-316" />
                      <XAxis dataKey="name" hide data-id="element-317" />
                      <Tooltip cursor={{
                    fill: 'transparent'
                  }} data-id="element-318" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-slate-50" data-id="element-319">
                  <div className="flex items-center gap-2 text-red-500 text-sm font-bold" data-id="element-320">
                    <AlertTriangle size={16} data-id="element-321" />
                    <span data-id="element-322">Peak on Wednesday</span>
                  </div>
                  <button className="text-[#2E3192] text-xs font-bold" data-id="element-323">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'calendar' && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-324">
            <div className="flex items-center justify-between" data-id="element-325">
              <div className="flex items-center gap-4" data-id="element-326">
                <button className="p-2 bg-white border border-slate-200 rounded-lg" data-id="element-327">
                  <ChevronLeft size={20} data-id="element-328" />
                </button>
                <div className="text-xl font-bold" data-id="element-329">July 2026</div>
                <button className="p-2 bg-white border border-slate-200 rounded-lg" data-id="element-330">
                  <ChevronRight size={20} data-id="element-331" />
                </button>
              </div>
              <div className="flex gap-2" data-id="element-332">
                <StatusLegend color="bg-green-500" label="Available" data-id="element-333" />
                <StatusLegend color="bg-yellow-500" label="Almost Full" data-id="element-334" />
                <StatusLegend color="bg-red-500" label="Full" data-id="element-335" />
              </div>
            </div>

            <div className="grid grid-cols-7 gap-4" data-id="element-336">
              {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => <div key={d} className="text-center text-xs font-bold text-slate-400 uppercase py-2" data-id="element-337">
                  {d}
                </div>)}
              <CalendarDay day="11" usage={85} appointments={18} status="Almost Full" data-id="element-338" />
              <CalendarDay day="12" usage={42} appointments={12} status="Available" data-id="element-339" />
              <CalendarDay day="13" usage={100} appointments={24} status="Full" data-id="element-340" />
              <CalendarDay day="14" usage={65} appointments={15} status="Available" data-id="element-341" />
              <CalendarDay day="15" usage={0} appointments={0} status="Holiday" isHoliday data-id="element-342" />
              <CalendarDay day="16" usage={20} appointments={5} status="Available" data-id="element-343" />
              <CalendarDay day="17" usage={15} appointments={3} status="Available" data-id="element-344" />
            </div>
          </div>}

        {activeTab === 'config' && <div className="space-y-6 animate-in fade-in duration-500" data-id="element-345">
            <div className="flex items-center justify-between" data-id="element-346">
              <BilingualText en="Capacity Adjustments" ar="تعديلات السعة" className="text-xl" data-id="element-347" />
              <button className="btn-primary py-2 px-4 text-sm" data-id="element-348">
                <Plus size={18} data-id="element-349" />
                <span data-id="element-350">New Adjustment</span>
              </button>
            </div>
            <div className="card overflow-hidden" data-id="element-351">
              <table className="w-full text-left" data-id="element-352">
                <thead className="bg-slate-50 text-slate-400 text-xs uppercase tracking-wider" data-id="element-353">
                  <tr data-id="element-354">
                    <th className="px-6 py-4 font-bold" data-id="element-355">Date</th>
                    <th className="px-6 py-4 font-bold" data-id="element-356">Adjustment</th>
                    <th className="px-6 py-4 font-bold" data-id="element-357">Reason</th>
                    <th className="px-6 py-4 font-bold" data-id="element-358">Final Capacity</th>
                    <th className="px-6 py-4 font-bold" data-id="element-359">Changed By</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-360">
                  <AdjustmentRow date="July 15, 2026" change="-2,000" reason="Staff Shortage" final="8,000" user="John Doe" data-id="element-361" />
                  <AdjustmentRow date="July 23, 2026" change="-10,000" reason="Public Holiday" final="0" user="System" data-id="element-362" />
                  <AdjustmentRow date="July 28, 2026" change="+2,500" reason="High Demand" final="12,500" user="Admin" isIncrease data-id="element-363" />
                </tbody>
              </table>
            </div>
          </div>}
      </main>
    </div>;
}
function TabButton({
  active,
  onClick,
  en,
  ar
}: any) {
  return <button onClick={onClick} className={`pb-4 px-2 transition-all relative ${active ? 'text-[#2E3192] font-bold' : 'text-slate-400 hover:text-slate-600'}`} data-id="element-364">
      <BilingualText en={en} ar={ar} className="text-sm" data-id="element-365" />
      {active && <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#2E3192] rounded-t-full" data-id="element-366" />}
    </button>;
}
function CapacityKpi({
  title,
  value,
  unit,
  icon: Icon,
  color,
  bgColor
}: any) {
  return <div className="card p-5 space-y-4" data-id="element-367">
      <div className="flex items-center justify-between" data-id="element-368">
        <div className={`p-2 rounded-lg ${bgColor} ${color}`} data-id="element-369">
          <Icon size={20} data-id="element-370" />
        </div>
      </div>
      <div data-id="element-371">
        <div className="text-slate-400 text-xs font-bold uppercase tracking-wider" data-id="element-372">
          {title}
        </div>
        <div className="flex items-baseline gap-2" data-id="element-373">
          <span className="text-2xl font-bold text-slate-800" data-id="element-374">{value}</span>
          <span className="text-xs text-slate-500 font-medium" data-id="element-375">{unit}</span>
        </div>
      </div>
    </div>;
}
function StatusLegend({
  color,
  label
}: any) {
  return <div className="flex items-center gap-2" data-id="element-376">
      <div className={`w-3 h-3 rounded-full ${color}`} data-id="element-377" />
      <span className="text-xs text-slate-500 font-medium" data-id="element-378">{label}</span>
    </div>;
}
function CalendarDay({
  day,
  usage,
  appointments,
  status,
  isHoliday = false
}: any) {
  const getColor = (u: number) => {
    if (isHoliday) return 'bg-slate-50 border-slate-100 opacity-50';
    if (u >= 90) return 'bg-red-50 border-red-100';
    if (u >= 70) return 'bg-yellow-50 border-yellow-100';
    return 'bg-green-50 border-green-100';
  };
  const getTextColor = (u: number) => {
    if (isHoliday) return 'text-slate-300';
    if (u >= 90) return 'text-red-700';
    if (u >= 70) return 'text-yellow-700';
    return 'text-green-700';
  };
  return <div className={`card p-4 h-32 flex flex-col justify-between transition-all hover:shadow-md cursor-pointer ${getColor(usage)}`} data-id="element-379">
      <div className="flex justify-between items-start" data-id="element-380">
        <span className="font-bold text-lg" data-id="element-381">{day}</span>
        {!isHoliday && <span className={`text-[10px] font-black uppercase ${getTextColor(usage)}`} data-id="element-382">
            {status}
          </span>}
      </div>
      {!isHoliday ? <div className="space-y-1" data-id="element-383">
          <div className="text-[10px] text-slate-400 font-bold uppercase" data-id="element-384">
            Usage
          </div>
          <div className="w-full bg-white/50 h-1.5 rounded-full overflow-hidden" data-id="element-385">
            <div className={`h-full ${usage >= 90 ? 'bg-red-500' : usage >= 70 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{
          width: `${usage}%`
        }} data-id="element-386" />
          </div>
          <div className="flex justify-between text-[10px] font-bold text-slate-500" data-id="element-387">
            <span data-id="element-388">{usage}%</span>
            <span data-id="element-389">{appointments} Appts</span>
          </div>
        </div> : <div className="text-[10px] font-bold text-slate-300 uppercase text-center italic" data-id="element-390">
          Warehouse Closed
        </div>}
    </div>;
}
function AdjustmentRow({
  date,
  change,
  reason,
  final,
  user,
  isIncrease = false
}: any) {
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-391">
      <td className="px-6 py-4 font-bold text-slate-700" data-id="element-392">{date}</td>
      <td className="px-6 py-4" data-id="element-393">
        <div className={`flex items-center gap-1 font-bold ${isIncrease ? 'text-green-600' : 'text-red-600'}`} data-id="element-394">
          {isIncrease ? <ArrowUpRight size={14} data-id="element-395" /> : <ArrowDownRight size={14} data-id="element-396" />}
          {change}
        </div>
      </td>
      <td className="px-6 py-4 text-sm text-slate-600" data-id="element-397">{reason}</td>
      <td className="px-6 py-4 font-bold text-slate-700" data-id="element-398">{final}</td>
      <td className="px-6 py-4 text-sm text-slate-500" data-id="element-399">{user}</td>
    </tr>;
}